import React, { useCallback, useMemo, useState } from "react";
import { DataGrid } from "@mui/x-data-grid";
import { Box, Stack, Typography } from "@mui/material";
import "./muiTable.scss";

function MuiTable({
  initialRows,
  columns,
  headerBgColor,
  defaultSort,
  subHeight,
  footer,
  border,
  minRowHeight,
  getRowHeight = "",
  padding = "",
}) {
  const [rows, setRows] = useState([""]);
  const [selectedRows, setSelectedRows] = useState([]);

  const handleSelectionChange = useCallback((selectionModel) => {
    const newSelectedRow = selectionModel[0];
    if (newSelectedRow != null && !selectedRows.includes(newSelectedRow)) {
      setSelectedRows((prev) => [...prev, newSelectedRow]);
      setRows((prevRows) =>
        prevRows.map((row) =>
          row.id === newSelectedRow ? { ...row, disabled: true } : row
        )
      );
    }
  }, [selectedRows]);

  const getRowClassName = useCallback((params) => {
    const { row } = params;
    return row?.is_archive ? "inactive-row" : "active-row";
  }, []);

  const CustomNoRowsOverlay = useMemo(() => {
    return () => (
      <Stack justifyContent="center" height="100%">
        <Typography variant="subtitle1" textAlign="center">
          No data found
        </Typography>
      </Stack>
    );
  }, []);

  return (
    <Box className="mui-table-container">
      <Box className={`mui-table-wrapper ${border ? 'with-borders' : ''}`}>
        <DataGrid
          className="custom-data-grid"
          rows={initialRows}
          getRowClassName={getRowClassName}
          columns={columns}
          disableColumnFilter
          disableColumnMenu
          disableSelectionOnClick={true}
          onSelectionModelChange={handleSelectionChange}
          slots={{ noRowsOverlay: CustomNoRowsOverlay }}
          selectionModel={selectedRows}
          initialState={{
            pagination: { paginationModel: { pageSize: 100 } },
            sorting: {
              sortModel: [{ field: defaultSort, sort: "asc" }],
            },
          }}
          autoHeight
          pageSizeOptions={[10, 20, 50, 100]}
          disableExtendRowFullWidth
          checkboxSelection={false}
          hideFooterSelectedRowCount
          showCellVerticalBorder={border}
          showColumnVerticalBorder={border}
          rowHeight={minRowHeight || 65}
          getRowHeight={getRowHeight}
          hideFooter={footer}
        />
      </Box>
    </Box>
  );
}

export default React.memo(MuiTable);

